import React from 'react';
import {MasterLayout} from 'components/layouts';
import {RegisterBusinessForm} from 'components/business';
import title from 'constants/TitlePages.js';
import {MemberZone} from 'pages/users';

class RegisterBusiness extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.registerBusiness;
  }

  onUnauthorized() {
    return new Promise((resolve, reject) => {

      resolve();
    });
  }

  render() {
    return (
      <MasterLayout isActive='register-business'>
        <RegisterBusinessForm/>
      </MasterLayout>
    );
  }
}

export default MemberZone(RegisterBusiness);



// WEBPACK FOOTER //
// ./pages/businesses/RegisterBusiness.jsx